<template>
   <section class="bg-white flex flex-col xl:flex-row justify-center items-center px-6 md:px-5 py-10 md:py-12 xl:py-0 relative antialiased ">
  <img src="@/assets/bg2.svg" alt="Background Decoration" class="absolute top-0 right-0 z-0 w-full xl:w-1/3 lg:auto opacity-100">
  <!-- Left: Image -->
  <div class="flex-1 flex justify-center z-20">
    <img src="@/assets/connect.svg" alt="Connect Illustration" class=":max-w-3xl h-auto">
  </div>

  <!-- Right: Contact Info -->
  <div class="flex-1 px-6 md:px-10 pt-6 md:pt-10 xl:pt-0 z-40">
    <div class="mb-8">
      <div class="flex items-center justify-start mb-6">
        <div class="h-7 w-1 bg-[#186a85] rounded-lg"></div>
        <span class="px-3 py-1 text-[#186a85] text-md font-medium tracking-wider">Contact Us</span>
      </div>
      <h3 class="text-2xl md:text-3xl font-semibold text-gray-800">Let's Connect</h3>
      <div class="w-20 h-1 bg-[#186a85] mt-4 mb-4 opacity-50"></div>
      <p class="text-gray-500 text-base md:text-lg leading-relaxed">
        Feel free to contact us anytime. We will get back to you as soon as we can.
      </p>
    </div>

   <!-- Contact Details -->
<div class="grid grid-cols-1 gap-6">
  <div class="flex items-start space-x-5 group transform hover:translate-x-2 transition-all duration-300">
    <div class="p-4 rounded-full shadow-md bg-white group-hover:bg-[#186a85] transition-all flex justify-center items-center">
      <img src="https://www.svgrepo.com/show/532125/clock-two.svg" alt="Clock Icon" class="w-8 h-8 transition-all group-hover:brightness-0 group-hover:invert">
    </div>
    <div>
      <p class="text-[#186a85] text-lg font-medium">Operational Hours</p>
      <p class="text-gray-700 text-md">Monday - Friday</p>
      <p class="text-gray-700 font-medium">09:00 - 16:00</p>
    </div>
  </div>

  <div class="flex items-start space-x-5 group transform hover:translate-x-2 transition-all duration-300">
    <div class="p-4 rounded-full shadow-md bg-white group-hover:bg-[#186a85] transition-all flex justify-center items-center">
      <img src="https://www.svgrepo.com/show/425565/costumer-service-customer-helpdesk.svg" alt="Support Icon" class="w-8 h-8 transition-all group-hover:brightness-0 group-hover:invert">
    </div>
    <div>
      <p class="text-[#186a85] text-lg font-medium">Support</p>
      <p class="text-gray-700 text-md">halo@phisoft.co.id</p>
      <p class="text-gray-700 font-medium">(081) 11623222</p>
    </div>
  </div>

  <div class="flex items-start space-x-5 group transform hover:translate-x-2 transition-all duration-300">
    <div class="p-4 rounded-full shadow-md bg-white group-hover:bg-[#186a85] transition-all flex justify-center items-center">
      <img src="https://www.svgrepo.com/show/522166/location.svg" alt="Location Icon" class="w-10 h-10 transition-all group-hover:brightness-0 group-hover:invert">
    </div>
    <div>
      <p class="text-[#186a85] text-lg font-medium">Address</p>
      <p class="text-gray-700 text-md">Gold Coast Office, Liberty Tower OTB 20B Pantai Indah Kapuk, Kota Jakarta Utara, Daerah Khusus Ibukota Jakarta, 14470 - Indonesia</p>
    </div>
  </div>
</div>
  </div>
</section>
  </template>
  
  <script setup>

  </script>
  